import { styled, theme } from "@theme/stitches.config"
// eslint-disable-next-line import/no-unresolved
import { Swiper } from "swiper/react"

export const ContentContainer = styled("div", {
    maxWidth: "100%",
    minHeight: "70vh",
    pt: 250,
    pb: 120,
    width: 500,
    zIndex: 1,
    position: "relative",
    display: "flex",
    alignItems: "flex-end",
    "h1, h2, h3, h4, h5, .h1, .h2, .h3, .h4, .h5": {
        color: "#fff"
    },
    "p:not([class]), p a": {
        color: "rgba(255, 255, 255, 0.65)"
    },
    "& > div": {
        pointerEvents: "all"
    },
    "& h3": {
        color: theme.colors.N0
    }
})
export const ContentSlidesWrapper = styled("div", {
    width: "100%",
    position: "relative",
    overflow: "hidden"
})

export const StyledSwiper = styled(Swiper, {
    position: "absolute !important",
    height: "100%",
    width: "100%",
    zIndex: "0 !important",
    overflow: "visible"
})

export const PaginationWrapper = styled("div", {})

export const Nav = styled("div", {
    marginLeft: "auto",
    position: "absolute",
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    right: 30,
    bottom: 120,
    pointerEvents: "all",
    "& .swiper-pagination-bullet": {
        border: `1px solid ${theme.colors.N0}`,
        background: "transparent"
    },
    "& .swiper-pagination-bullet-active": {
        backgroundColor: theme.colors.effieGold,
        border: 0
    },
    "& .swiper-button-disabled": {
        opacity: 0.5,
        pointerEvents: "none"
    },
    "@smDown": {
        display: "none"
    }
})

export const StyledImage = styled("div", {
    height: "100%",
    "& > img, & > .gatsby-image-wrapper": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
})
